import React from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

const isSafeLink = (url) => /^(https?:\/\/|mailto:|\/(?!\/))/i.test(url || '');

const SafeLink = ({ href, children }) => {
  if (!isSafeLink(href)) {
    return <>{children}</>;
  }

  if (/^https?:\/\//i.test(href)) {
    return <a href={href} target='_blank' rel='noopener noreferrer'>{children}</a>;
  }

  if (href.startsWith('/')) {
    return <Link to={href}>{children}</Link>;
  }

  return <a href={href}>{children}</a>;
};

const Table = ({ children }) => <div className='aes-ai-chat-markdown-table'><table>{children}</table></div>;

const AssistantMarkdown = ({ children }) => (
  <ReactMarkdown
    className='aes-ai-chat-markdown'
    escapeHtml
    plugins={[gfm]}
    renderers={{ link: SafeLink, table: Table }}
  >
    {children || ''}
  </ReactMarkdown>
);

export { isSafeLink };
export default AssistantMarkdown;
